import {Field, Form, Formik} from 'formik'
import {sha256} from 'js-sha256'
import * as Yup from 'yup'

import {toast} from 'react-toastify'

import {useIntl} from 'react-intl'
import Logo from '../../../_metronic/assets/logo.png'
import BG from '../asset/bg.png'
import {LanguageList} from '../helper/languageList'
import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import PasswordChecklist from 'react-password-checklist'
import {API} from 'src/feature/bite/domain'
import useRequestParams from 'src/feature/bite/hook/request'

export default function NewPassword() {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const {headers} = useRequestParams()

  const [passwordShown, setPasswordShown] = useState(false)
  const [passwordConfirmShown, setPasswordConfirmShown] = useState(false)
  const [passwordValid, setPasswordValid] = useState(false)

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    password: Yup.string().required(' ').min(6, ' ').max(50, ' '),
    confirmPassword: Yup.string()
      .required(' ')
      .oneOf([Yup.ref('password'), ''], ' '),
    email: Yup.string().email(' ').required(' '),
  })

  useEffect(() => {
    if (!(location as any).state?.email) {
      navigate('/')
    }
  }, [location, navigate])

  const handleSubmit = async (values: any) => {
    if (!passwordValid) {
      return
    }

    //`${API}/Auth/ChangePassword`
    const Response = await fetch(`${API}/Auth/OutChangePassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      body: JSON.stringify({
        email: values.email,
        temporaryPassword: sha256(values.oldPassword),
        newPassword: sha256(values.password),
        language: headers.Language,
      }),
    })

    const data = await Response?.json()
    if (!data.responseResult.result) {
      toast.error(intl.formatMessage({id: 'CREATE_PASSWORD.ERROR'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
    } else {
      toast.success(intl.formatMessage({id: 'PASSWORD_CHANGED'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
      window.location.href = '/sign-in'
    }
  }

  return (
    <div className='d-flex flex-column flex-root' id='kt_app_root'>
      <div className='d-flex flex-column flex-lg-row flex-column-fluid'>
        <a href='sign-in' className='d-block d-lg-none mx-auto pt-10'>
          <img alt='Logo' src={Logo} className='h-25px' />
        </a>

        <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10'>
          <div className='d-flex justify-content-between flex-column-fluid flex-column w-100 mw-450px gap-10'>
            <div className='d-flex flex-stack py-2'>
              <div className='m-0'>
                <div className='d-none d-md-block'>
                  <img
                    alt='Extra360 - Merchant Portal'
                    src={Logo}
                    style={{
                      width: '250px',
                    }}
                  />
                </div>
                <h1
                  className='text-gray-400 mb-3 fs-3x mt-0 mt-md-3'
                  data-kt-translate='sign-in-title'
                >
                  {intl.formatMessage({id: 'APP_NAME'})}
                </h1>
              </div>
            </div>
            <div className=''>
              <Formik
                className='form w-100'
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                initialValues={{
                  oldPassword: '',
                  password: '',
                  confirmPassword: '',
                  email: (location as any).state?.email,
                  /* email: 'omer.yucel+10@extra360.io', */
                }}
              >
                {({errors, values, touched}) => (
                  <Form>
                    <div className='text-start mb-7'>
                      <h1 className='text-primary mb-3 fs-3x' data-kt-translate='sign-in-title'>
                        {intl.formatMessage({id: 'AUTH.LOGIN.CREATE_PW'})}
                      </h1>

                      <div
                        className='text-gray-400 fw-semibold fs-6'
                        data-kt-translate='password-reset-desc'
                      >
                        {intl.formatMessage({id: 'AUTH.LOGIN.CREATE_PW_DESC'})}
                      </div>
                    </div>
                    <div className='fv-row mb-7 form-floating'>
                      <Field
                        type='password'
                        id='oldPassword'
                        name='oldPassword'
                        className='form-control mb-2'
                        placeholder='Old Password'
                      />
                      <label>{intl.formatMessage({id: 'AUTH.INPUT.OLD_PASSWORD'})}</label>
                      {errors.oldPassword && touched.oldPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.oldPassword}</div>
                        </div>
                      )}
                    </div>
                    <div className='fv-row mb-7 form-floating'>
                      {/* eye icon */}
                      <div
                        className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                        style={{cursor: 'pointer'}}
                        onClick={() => setPasswordShown(!passwordShown)}
                      >
                        <i
                          className={`bi ${passwordShown ? 'bi-eye-slash' : 'bi-eye'}`}
                          style={{fontSize: '1.4rem'}}
                        ></i>
                      </div>
                      <Field
                        type={passwordShown ? 'text' : 'password'}
                        name='password'
                        className='form-control mb-2'
                        placeholder='Password'
                      />
                      <label>{intl.formatMessage({id: 'AUTH.INPUT.NEW_PASSWORD'})}</label>
                      {/* {errors.password && touched.password && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.password}</div>
                        </div>
                      )} */}
                    </div>

                    <div className='fv-row mb-7 form-floating'>
                      <div
                        className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                        style={{cursor: 'pointer'}}
                        onClick={() => setPasswordConfirmShown(!passwordConfirmShown)}
                      >
                        <i
                          className={`bi ${passwordConfirmShown ? 'bi-eye-slash' : 'bi-eye'}`}
                          style={{fontSize: '1.4rem'}}
                        ></i>
                      </div>
                      <Field
                        type={passwordConfirmShown ? 'text' : 'password'}
                        name='confirmPassword'
                        className='form-control mb-2'
                        placeholder='Confirm Password'
                      />
                      <label>{intl.formatMessage({id: 'AUTH.INPUT.NEW_CONFIRM_PASSWORD'})}</label>
                      {/*  {errors.confirmPassword && touched.confirmPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.confirmPassword}</div>
                        </div>
                      )} */}
                    </div>

                    <div>
                      <PasswordChecklist
                        className='mb-7'
                        rules={[
                          'minLength',
                          'specialChar',
                          'number',
                          'capital',
                          'lowercase',
                          'match',
                        ]}
                        minLength={6}
                        value={values.password}
                        valueAgain={values.confirmPassword}
                        onChange={(isValid) => {
                          setPasswordValid(isValid)
                        }}
                        messages={{
                          minLength: intl.formatMessage({id: 'FORGOT.PASSWORD.RULES.MIN_LENGTH'}),
                          specialChar: 'At least one special character (e.g. !@#$%^&*)',
                          number: 'At least one number (e.g. 0-9)',
                          capital: 'At least one capital letter (e.g. A-Z)',
                          lowercase: 'At least one lowercase letter (e.g. a-z)',
                          match: 'Passwords must match',
                        }}
                      />
                    </div>
                    <div className='d-flex flex-stack'>
                      <div className='m-0'>
                        <button
                          // id='kt_password_reset_submit'
                          type='submit'
                          className='btn btn-primary me-2'
                          // data-kt-translate='password-reset-submit'
                        >
                          <i className='bi bi-arrow-right me-3 fs-3'></i>
                          <span className='indicator-label'>
                            {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                          </span>

                          <span className='indicator-progress'>
                            {intl.formatMessage({id: 'PLEASE_WAIT'})}
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        </button>
                        <a
                          href='sign-in'
                          className='btn fw-bold'
                          data-kt-translate='password-reset-cancel'
                        >
                          {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
                        </a>
                      </div>
                    </div>
                    <div className='mt-10'>
                      <LanguageList />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            <div></div>
          </div>
        </div>

        <div
          className='d-none d-lg-flex flex-lg-row-fluid w-50 bgi-size-cover bgi-position-y-center bgi-position-x-start bgi-no-repeat'
          style={{
            backgroundImage: `url(${BG})`,
          }}
        ></div>
      </div>
    </div>
  )
}
